import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { addFlashMessage } from '../../helpers/FlashMessages';

const ShareLinkCopy = ({
  id,
  linkUrl,
  text,
  tooltipText,
  showTooltip,
}) => {
  const [linkCopied, setLinkCopied] = useState(false);

  const intl = useIntl();

  const copyLink = (e) => {
    e.preventDefault();
    setLinkCopied(true);
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({ defaultMessage: 'The link was copied to your clipboard!' }),
      duration: 5000,
    });
  };

  if (!linkUrl) {
    return null;
  }

  return (
    <div className="share-item-link">
      <CopyToClipboard
        text={linkUrl}
        options={{
          format: 'text/plain',
        }}
      >
        <a
          id={id}
          className={classnames('share-link-copy', { copied: linkCopied })}
          href="#copy-link"
          onClick={(e) => {
            copyLink(e);
          }}
        >
          <span className="text-nowrap">{text}&nbsp;<i className="far fa-clone" /></span>
        </a>
      </CopyToClipboard>
      {showTooltip && (
        <UncontrolledTooltip fade={false} placement="bottom" target={id}>
          {tooltipText || (linkCopied ? intl.formatMessage({ defaultMessage: 'Link was copied to your clipboard' }) : intl.formatMessage({ defaultMessage: 'Copy link' }))}
        </UncontrolledTooltip>
      )}
    </div>
  );
};

ShareLinkCopy.propTypes = {
  id: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  text: PropTypes.string,
  tooltipText: PropTypes.string,
  showTooltip: PropTypes.bool,
};

ShareLinkCopy.defaultProps = {
  text: '',
  tooltipText: undefined,
  showTooltip: true,
};

export default ShareLinkCopy;
